module.exports = __webpack_public_path__ + "media/images/rides/icon2-911aadd2849909e9368f8626d92cb4b2.svg";